<template>
  <div>
    <b-card header="Browse PPFTZ Manual">
      <loading :active.sync="this.$store.state.barpin.isLoading" :is-full-page="false"></loading>
      <div class>
        <div class="row">
          <div class="col-sm-12 col-md-6 my-2">
            <input type="text" placeholder="Pencarian" class="form-control" v-model="searchFilter" />
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="row">
              <div class="col-sm-12 col-md-6 my-2">
                <select class="form-control" v-model="current_status">
                  <option value="">Status</option>
                  <option v-for="item in status" :value="item.status" :key="item.status">{{ item.ur_status}}</option>
                </select>
              </div>
              <div class="col-sm-12 col-md-6 my-2">
                <b-form-fieldset>
                  <b-form-select v-model="jns_aju" :plain="true" :options="[
                  {
                    text: 'Jenis Aju',
                    value: ''
                  },
                  {
                    text: 'Barang Pindahan',
                    value: '1'
                  },
                  {
                    text: 'Kendaraan Bermotor',
                    value: '2'
                  }]">
                  </b-form-select>
                </b-form-fieldset>
              </div>
              <!-- <router-link to="/menup2/intel/add"> <button type="button" class="btn btn-success" name="button" router > <i class="fa fa-plus"></i> Tambah NHI</button></router-link> -->
            </div>
          </div>
        </div>
        <div class="row" v-if="!this.$store.state.barpin.isLoading">
          <div class="col-12">
            <table class="table table-bordered table-responsive">
              <thead>
                <tr>
                  <th>No. Aju</th>
                  <th>No. Daftar</th>
                  <th>Nama Penerima</th>
                  <th>Jenis Pengajuan</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in pageOfItems" :key="data.NO_AJU">
                  <td>{{ data.NO_AJU}}</td>
                  <td>{{ data.NO_DAFTAR}}</td>
                  <td>{{ data.NAMA_PENERIMA}}</td>
                  <td>{{ data.JNS_AJU == '1' ? 'Barang Pindahan' : 'Kendaraan Bermotor'}}</td>
                  <td>{{ data.status.ur_status}}</td>
                  <td>

                    <router-link class="btn btn-primary" :to="`browse/${ data.NO_AJU }`">
                      <i class="fa fa-search"></i>
                    </router-link>
                    <b-button variant="success" v-b-modal.modal-respon
                      @click="setRespon(data.encoded_id, data.KD_STATUS, data.NO_AJU)"><i class="fa fa-download"></i>
                    </b-button>
                    <b-button variant="secondary" v-b-modal.modal-catatan @click="getCatatan(data.ID_AJU)"><i
                        class="fa fa-bars"></i></b-button>
                    <b-button v-if="data.KD_STATUS === '115'" title="Rekam Bukti Bayar" variant="secondary"
                      v-b-modal.modal-billing @click="setBilling(data.NO_AJU)"><i class="fa fa-edit"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="card-footer pb-0 pt-3">
              <jw-pagination :items="filteredData" @changePage="onChangePage"></jw-pagination>
            </div>
          </div>
        </div>
      </div>
    </b-card>
    <modal-respon />
    <modal-catatan />
    <modal-billing />
  </div>
</template>

<script>
// import swal from 'sweetalert'
import {mapActions} from 'vuex'
import {HalfCircleSpinner} from 'epic-spinners'
import ModalRespon from './modal/ModalRespon.vue'
import ModalCatatan from './modal/ModalCatatan.vue'
import ModalBilling from './modal/ModalBilling.vue'

export default {
  data () {
    return {
      ppftz: [],
      pageOfItems: [],
      searchFilter: '',
      jns_aju: '',
      status: [],
      current_status: ''
    }
  },
  components: {
    HalfCircleSpinner,
    ModalRespon,
    ModalCatatan,
    ModalBilling
  },
  mounted () {
    // LOAD FUNGSI SAAT HALAMAN DIBUKA ---------------------------------------------------------
    this.browse()
    this.refStatus()
  },
  computed: {
    // FUNGSI PENCARIAN -------------------------------------------------------------------------  
    filteredData: function () {
      return this.ppftz.filter((items) => {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(this.searchFilter.toLowerCase()) !== -1) {
            return true
          }
        }
        return false
      }).filter((items) => {
        if (this.jns_aju === '') return true
        if (items.JNS_AJU === this.jns_aju) return true
        return false
      }).filter((items) => {
        if (this.current_status === '') return true
        if (items.KD_STATUS === this.current_status) return true
        return false
      })
    }
  },
  methods: {
    ...mapActions({
      getCatatan: 'barpin/getCatatan'
    }),
    // METHOD GET ------------------------------------------------------------  
    browse () {
      this.$store.commit('barpin/SET_LOADING', true)
      this.$http.get('ppftz').then((response) => {
        this.ppftz = response.data
        this.$store.commit('barpin/SET_LOADING', false)
      })
    },
    setRespon (encodedId, status, noAju) {
      this.$store.commit('barpin/SET_LOADING_MODAL', true)
      this.$store.commit('barpin/SET_RESPON', {id: encodedId, status: status})
      this.$store.dispatch('barpin/getData', noAju).then(() => {
        this.$store.commit('barpin/SET_LOADING_MODAL', false)
      })
    },
    setBilling (id, noAju) {
      this.$store.commit('barpin/SET_BILLING_ID', id)
    },
    refStatus () {
      this.$http.get('ref/status').then((response) => {
        this.status = response.data.filter((items) => items.status >= 110)
      })
    },
    // CONTOH SWEETALERT METHOD POST -------------------------------------------
    // kirim () {
    //   swal({
    //     title: 'Data akan dikirim?',
    //     text: 'Apakah anda yakin akan mengirim data ini?',
    //     icon: 'warning',
    //     buttons: true
    //     // dangerMode: true,
    //   }).then((value) => {
    //     if (value) {
    //       // this.isLoading = true
    //       this.$Progress.start()
    //       const kirim = {
    //         id: id,
    //         fl_hold: hold,
    //         nip_rekam: this.$store.getters['auth/user']['username']
    //       }
    //       this.$http.put('menup2/intel/nhi', kirim).then((response) => {
    //         this.$Progress.finish()
    //         swal(
    //           response.data.status,
    //           response.data.message,
    //           response.data.status
    //         )
    //         this.browse()
    //       })
    //     }
    //   })
    // },

    // PAGINATION -----------------------------------------------
    onChangePage (pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems
    }
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/ppftz/Browse.vue?9462eae4